import type { TranslationDataObj } from './type';

export const data: TranslationDataObj = {
  'app.billing.general': {
    editPlan: {
      en: 'Edit plan',
      fr: 'Modifier le plan',
    },
    contactSupportToEditPlan: {
      en: 'Contact support to update plan',
      fr: 'Contactez le support pour mettre à jour le plan',
    },
    yearlyWithDiscount: {
      en: 'Yearly -{{ percent }}% off',
      fr: 'Annuel -{{ percent }}% de réduction',
    },
    switchToMonthlyPlan: {
      en: 'Switch to Monthly Plan',
      fr: 'Passer au plan mensuel',
    },
    switchToYearlyPlan: {
      en: 'Switch to Yearly Plan',
      fr: 'Passer au plan annuel',
    },
    upgrade: {
      en: 'Upgrade',
      fr: 'Mettre à niveau',
    },
    downgrade: {
      en: 'Downgrade',
      fr: 'Rétrograder',
    },
    effectiveImmediately: {
      en: 'Effective immediately',
      fr: 'Effectif immédiatement',
    },
    effectiveOn: {
      en: 'Effective on {{date}}',
      fr: 'Effectif le {{date}}',
    },
    contactUs: {
      en: 'Contact us',
      fr: 'Contactez-nous',
    },
    seeFullFeatureComparison: {
      en: 'See full feature comparison',
      fr: 'Voir la comparaison des fonctionnalités',
    },
    noCredits: {
      en: 'No credits left',
      fr: 'Plus de crédits',
    },
    increaseLimitOwner: {
      en: 'To increase your limit, please contact our team.',
      fr: 'Pour augmenter votre limite, veuillez contacter notre équipe.',
    },
    increaseLimitNonOwner: {
      en: 'To increase your limit, reach out to your organization owner.',
      fr: 'Pour augmenter votre limite, contactez votre propriétaire de l’organisation.',
    },
    increaseLimitProduct: {
      en: 'To keep creating new product pages, contact the support.',
      fr: 'Pour continuer à créer de nouvelles pages produit, contactez le support.',
    },
    startTrial: {
      en: 'Start {{trialDays}}-day free trial',
      fr: 'Essai gratuit {{trialDays}} jours!',
    },
    choosePlan: {
      en: 'Choose plan',
      fr: 'Choisir le plan',
    },
    chooseYourPlan: {
      en: 'Choose a plan to start your <br><span class="text-branding-accent-800 font-display-2">{{trialDays}}-day free trial</span>',
      fr: 'Choisissez un abonnement pour commencer votre <br><span class="text-branding-accent-800 font-display-2">essai gratuit de {{trialDays}} jours</span>',
    },
    reactivatePlanTitle: {
      en: 'Plan cancelled.<br> <span class="text-branding-accent-800 font-display-2">Reactivate your plan to continue <br>generating content. </span>',
      fr: 'Plan annulé.<br> <span class="text-branding-accent-800 font-display-2">Réactivez votre plan pour continuer<br> à générer du contenu. </span>',
    },
    reactivatePlanSeoStrategyTitle: {
      en: 'Plan cancelled.<br> <span class="text-branding-accent-800 font-display-2">Reactivate your plan to generate <br>your SEO strategy. </span>',
      fr: 'Plan annulé.<br> <span class="text-branding-accent-800 font-display-2">Réactivez votre plan pour générer <br>votre stratégie SEO. </span>',
    },
    fullAccess: {
      en: 'Power your creativity with full access',
      fr: 'Développez votre créativité avec un accès complet',
    },
    bestInClase: {
      en: 'Our plans include our best-in-class AI features to create expert-grade, SEO-ready e-commerce content.',
      fr: 'Nos abonnements incluent nos meilleures fonctionnalités AI pour créer du contenu e-commerce de haute qualité, optimisé pour le SEO.',
    },
    exploreFeatures: {
      en: 'Explore all features',
      fr: 'Explorer toutes les fonctionnalités',
    },
    billingDetailsDescription: {
      en: 'Update your billing information and download your invoices.',
      fr: 'Mettre à jour vos informations de facturation et télécharger vos factures.',
    },
    billingDetails: {
      en: 'Billing details and invoicing',
      fr: 'Détails de la facturation',
    },
    paymentMethod: {
      en: 'Payment method',
      fr: 'Modes de paiement',
    },
    detailsAndInvoicing: {
      en: 'Billing details & invoices',
      fr: 'Factures',
    },
    cancelPlan: {
      en: 'Cancel plan',
      fr: 'Annuler le plan',
    },
    cancelPlanDescription: {
      en: 'We hate to see you go. Anything we could do to change your mind? ',
      fr: 'Nous sommes désolés de vous voir partir. Que pouvons-nous faire pour changer d’avis ?',
    },
    cancelPlanDescriptionModal: {
      en: "Are you sure you want to cancel your plan?<br/>You'll keep access until <strong>{{date}}</strong>, the end of your current billing period.",
      fr: "Êtes-vous sûr de vouloir annuler votre plan ?<br/>Vous garderez accès jusqu'au <strong>{{date}}</strong>, la fin de votre période de facturation actuelle.",
    },
    cancelPlanDescriptionTrial: {
      en: 'Are you sure you want to cancel your trial? Your access will end immediately.',
      fr: 'Êtes-vous sûr de vouloir annuler votre essai ? Votre accès prendra fin immédiatement.',
    },
    contactSupport: {
      en: 'Contact support',
      fr: 'Contacter le support',
    },
    cancelPlanBtn: {
      en: 'Cancel plan',
      fr: 'Résilier',
    },
    paymentFailed: {
      en: 'Payment failed',
      fr: 'Paiement échoué',
    },
    paymentFailedDescription: {
      en: 'Please update your billing details to keep your subscription active.',
      fr: 'Veuillez mettre à jour vos informations de facturation pour continuer à utiliser notre service.',
    },
    switchedPlan: {
      en: 'Plan change scheduled',
      fr: 'Changement de plan planifié',
    },
    switchedPlanDescription: {
      en: 'Your new plan will start on your next billing date: <strong>{{date}}</strong>',
      fr: 'Votre nouveau plan commencera à votre prochaine date de facturation: <strong>{{date}}</strong>',
    },
    updatePaymentMethod: {
      en: 'Update payment method',
      fr: 'Mettre à jour le mode de paiement',
    },
    reactivatePlan: {
      en: 'Reactivate plan',
      fr: 'Réactiver le plan',
    },
    paymentFailedTopBar: {
      en: '<b>Payment failed</b>. Please update your billing details to keep your subscription active.',
      fr: '<b>Paiement échoué</b>. Veuillez mettre à jour vos informations de facturation pour continuer à utiliser notre service.',
    },
    cancelledTopBar: {
      en: '<b>Your plan has been cancelled</b>. You’ll keep access until {{date}}.',
      fr: '<b>Votre plan a été annulé</b>. Vous garderez accès jusqu’au {{date}}.',
    },

    keepPlan: {
      en: 'Keep plan',
      fr: 'Garder le plan',
    },
    switchTo: {
      en: 'Switch to <span class="text-branding-accent capitalize font-display-3">{{plan}}</span> plan',
      fr: 'Passer sur le plan <span class="text-branding-accent capitalize font-display-3 ">{{plan}}</span>',
    },
    Year: {
      en: 'Yearly',
      fr: 'Annuel',
    },
    Month: {
      en: 'Monthly',
      fr: 'Mensuel',
    },
    switchToButtonYearly: {
      en: 'Switch to Yearly',
      fr: "Passer à l'Annuel",
    },
    switchToButtonMonthly: {
      en: 'Switch to Monthly',
      fr: 'Passer au mensuel',
    },
    reactivatePlanButton: {
      en: 'Reactivate plan',
      fr: 'Réactiver le plan',
    },
    noActiveSubscription: {
      en: 'No active subscription yet',
      fr: 'Aucun abonnement actif pour le moment',
    },
    titleCancelled: {
      en: 'Your subscription has been cancelled',
      fr: 'Votre abonnement a été annulé',
    },
    planCancelled: {
      en: 'Plan cancelled',
      fr: 'Votre plan a été annulé',
    },
    cancelledPlanBadge: {
      en: 'Plan cancelled',
      fr: 'Plan annulé',
    },
    noActiveSubscriptionDes: {
      en: 'The owner of this organization has not subscribed to a plan yet, so access is not available. Please reach out to your organization’s owner for help.',
      fr: 'Le propriétaire de cette organisation n’a pas encore souscrit à un plan, donc l’accès n’est pas disponible. Veuillez contacter le propriétaire pour obtenir de l’aide.',
    },
    planCancelledDes: {
      en: 'This organization’s plan was cancelled by its owner. Access is no longer available. Please contact the owner for assistance.',
      fr: 'Le plan de cette organisation a été annulé par son propriétaire. L’accès n’est plus disponible. Veuillez contacter le propriétaire pour obtenir de l’aide.',
    },
    paymentFailedDescriptionModal: {
      en: 'Payment failed while activating your plan. Please try again, or <0>contact support</0> if the issue continues.',
      fr: 'Paiement échoué lors de l’activation de votre plan. Veuillez réessayer, ou <0>contacter le support</0> si le problème persiste.',
    },
    trialSuccess: {
      en: 'Trial activated successfully',
      fr: 'Votre essai gratuit a été activé avec succès',
    },
    trialSuccessDescription: {
      en: 'Your {{trialDays}}-day free trial is active. No charges until the trial ends. Cancel at any time.',
      fr: 'Votre essai gratuit est actif. Aucun frais jusqu’à la fin de l’essai. Annuler à tout moment.',
    },
    subscriptionSuccess: {
      en: 'Subscription activated successfully',
      fr: 'Abonnement activé avec succès',
    },
    subscriptionSuccessDescription: {
      en: "Your subscription is now active and billing has started. You can manage your subscription in settings at any time. Let's get started!",
      fr: 'Votre abonnement est maintenant actif et la facturation a commencé. Vous pouvez gérer votre abonnement dans les paramètres à tout moment. C’est parti !',
    },
    subscriptionUpdated: {
      en: 'Success! Your Plan has been updated.',
      fr: 'Votre abonnement a été mis à jour avec succès',
    },
    creditsSuccess: {
      en: 'Credits added successfully',
      fr: 'Crédits ajoutés avec succès',
    },
    creditsSuccessDescription: {
      en: 'Your extra credits have been added to your account and are ready to use.',
      fr: 'Vos crédits supplémentaires ont été ajoutés à votre compte et sont prêts à être utilisés.',
    },
    subscriptionUpdatedDescription: {
      en: 'Your plan will switch to the <strong>{{plan}}</strong> plan starting on <strong>{{date}}</strong>. Until then, your current plan remains active. ',
      fr: 'Votre plan va passer au plan <strong>{{plan}}</strong>, commençant le <strong>{{date}}</strong>. Jusqu’à ce moment, votre plan actuel reste actif. ',
    },
    subscriptionUpdatedDescriptionImmediately: {
      en: 'Your account has been successfully updated to the <strong>{{ plan }}</strong> plan.',
      fr: 'Votre compte a été mis à jour avec succès vers le plan <strong>{{ plan }}</strong>.',
    },
    percentOff: {
      en: 'Save {{ percent }}%',
      fr: 'Économiser {{ percent }}%',
    },
    cancelPlanFailed: {
      en: 'Failed to cancel plan',
      fr: 'Échec de l’annulation du plan',
    },
    cancelPlanFailedDescription: {
      en: 'Please try again later.',
      fr: 'Veuillez réessayer plus tard.',
    },
    yearly: {
      en: 'Yearly',
      fr: 'Annuel',
    },
    monthly: {
      en: 'Monthly',
      fr: 'Mensuel',
    },
    planManagement: {
      en: 'Plan management',
      fr: 'Gestion du plan',
    },
    planManagementDescription: {
      en: 'To modify or cancel your subscription, please schedule a call with our team.',
      fr: 'Pour modifier ou annuler votre abonnement, veuillez planifier un appel avec notre équipe.',
    },
    bookCall: {
      en: 'Book a call',
      fr: 'Planifier un appel',
    },
    cancelReasonPrompt: {
      en: "We'd love to know why you're cancelling. Select all that apply.",
      fr: "Nous aimerions savoir pourquoi vous annulez. Sélectionnez tout ce qui s'applique.",
    },
    complicated: {
      en: 'Complicated to use',
      fr: 'Difficile à utiliser',
    },
    expensive: {
      en: 'Too expensive',
      fr: 'Trop cher',
    },
    outputBad: {
      en: "Output wasn't good",
      fr: 'Mauvaise qualité',
    },
    foundAnother: {
      en: 'Found another tool',
      fr: 'Trouvé un autre outil',
    },
    other: {
      en: 'Other',
      fr: 'Autre',
    },
    otherPlaceholder: {
      en: 'Please specify...',
      fr: 'Veuillez préciser...',
    },
    confirmCancellation: {
      en: 'Confirm cancellation',
      fr: "Confirmer l'annulation",
    },
    managePlan: {
      en: 'Manage plan',
      fr: 'Gérer le plan',
    },
    uncancelPlan: {
      en: 'Reactivate subscription',
      fr: 'Réactiver le plan',
    },
    plan: {
      en: 'Plan',
      fr: 'Plan',
    },
    billingCycle: {
      en: 'Billing cycle',
      fr: 'Cycle de facturation',
    },
    renewsOn: {
      en: 'Renews on',
      fr: 'Renouvelle le',
    },
    total: {
      en: 'Total',
      fr: 'Total',
    },
    perMonth: {
      en: '/per month',
      fr: '/par mois',
    },
    perMonthShort: {
      en: '/mo',
      fr: '/mois',
    },
    perYearShort: {
      en: '/yr',
      fr: '/an',
    },
    perYear: {
      en: '/per year',
      fr: '/par an',
    },
    billedMonthly: {
      en: 'Billed monthly',
      fr: 'Facturé mensuellement',
    },
    billedYearly: {
      en: 'Billed yearly',
      fr: 'Facturé annuellement',
    },
    billedAnnuallyAt: {
      en: 'Billed annually at {{ amount }}',
      fr: 'Facturé annuellement à {{ amount }}',
    },
    skipForNow: {
      en: 'Skip for now',
      fr: 'Passer pour le moment',
    },
    contentCreationsPerMonth: {
      en: '{{count}} content creations /mo',
      fr: '{{count}} créations de contenu /mois',
    },
    user: {
      en: '{{count}} user',
      fr: '{{count}} utilisateur',
    },
    users: {
      en: '{{count}} users',
      fr: '{{count}} utilisateurs',
    },
    usersUnlimited: {
      en: 'Unlimited users',
      fr: 'Utilisateurs illimités',
    },
    allAiModels: {
      en: 'All AI models',
      fr: 'Tous les modèles IA',
    },
    openAiModel: {
      en: 'Open AI model',
      fr: 'Modèle Open AI',
    },
    teamMembers: {
      en: 'Team members',
      fr: "Membres de l'équipe",
    },
    contentCreationAndRewrite: {
      en: 'Content creation, Rewrite & Other',
      fr: 'Génération de contenu, Réécriture & Autre',
    },
  },
  'components.credit-usage': {
    title: {
      en: 'CREDIT USAGE',
      fr: 'USAGE DE CRÉDITS',
    },
    subtitle: {
      en: 'Track your subscription usage and limits',
      fr: 'Suivez votre utilisation et vos limites',
    },
    percentUsed: {
      en: '{{percentage}}% of your monthly limit used',
      fr: '{{percentage}}% de votre limite mensuelle utilisée',
    },
    renews: {
      en: 'Renews {{date}}',
      fr: 'Renouvelle le {{date}}',
    },
    percentRemaining: {
      en: '{{percentage}}% remaining before restriction (until {{date}})',
      fr: "{{percentage}}% restant avant restriction (jusqu'au {{date}})",
    },
    buyCredits: {
      en: 'Buy credits',
      fr: 'Acheter des crédits',
    },
    extraCreditsCount: {
      en: 'Purchased credits <0>{{count}}</0> <1>(never expire)</1>',
      fr: `Crédits achetés <0>{{count}}</0> <1>(n'expire jamais)</1>`,
    },
  },
  'components.buy-credits-modal': {
    title: {
      en: 'Buy credits',
      fr: 'Acheter des crédits',
    },
    subtitle: {
      en: 'All credits are shared within the <strong>{{organizationName}}</strong> organization.',
      fr: "Tous les crédits sont partagés au sein de l'organisation <strong>{{organizationName}}</strong>.",
    },
    oneTimePurchase: {
      en: 'One time purchase. Extra credits never expire.',
      fr: "Achat unique. Les crédits supplémentaires n'expirent jamais.",
    },
    credits: {
      en: '{{count}} credits',
      fr: '{{count}} crédits',
    },
    total: {
      en: 'Total',
      fr: 'Total',
    },
    contentGeneration: {
      en: '{{count}} Content generation',
      fr: '{{count}} Génération de contenu',
    },
    rewrites: {
      en: '{{count}} Rewrites',
      fr: '{{count}} Réécritures',
    },
    or: {
      en: 'or',
      fr: 'ou',
    },
    conversionInfo: {
      en: '1 Content Generation = 1 Credit / 1 Rewrite = 0.5 Credit',
      fr: '1 Génération de contenu = 1 Crédit / 1 Réécriture = 0,5 Crédit',
    },
    cancel: {
      en: 'Cancel',
      fr: 'Annuler',
    },
    buyCreditsFor: {
      en: 'Buy credits for {{price}}',
      fr: 'Acheter des crédits pour {{price}}',
    },
  },
  'components.downgrade-impossible-modal': {
    title: {
      en: 'Unable to downgrade',
      fr: 'Impossible de rétrograder',
    },
    description: {
      en: 'You need to remove some users before downgrading to the {{planName}} plan.',
      fr: 'Vous devez supprimer des utilisateurs avant de rétrograder vers le plan {{planName}}.',
    },
    membersLabel: {
      en: 'Members',
      fr: 'Membres',
    },
    currentUsers: {
      en: 'You currently have {{count}} users',
      fr: 'Vous avez actuellement {{count}} utilisateurs',
    },
    planLimitsLabel: {
      en: '{{planName}} plan limits',
      fr: 'Limites du plan {{planName}}',
    },
    userLimit: {
      en: '{{count}} user',
      fr: '{{count}} utilisateur',
    },
    usersLimit: {
      en: '{{count}} users',
      fr: '{{count}} utilisateurs',
    },
    usersUnlimited: {
      en: 'Unlimited users',
      fr: 'Utilisateurs illimités',
    },
    manageMembers: {
      en: 'Manage Members',
      fr: 'Gérer les membres',
    },
    cancel: {
      en: 'Cancel',
      fr: 'Annuler',
    },
  },
  'components.trial-limit-plan-modal': {
    title: {
      en: 'You have reached your trial limit of {{count}} articles',
      fr: "Vous avez atteint votre limite d'essai de {{count}} articles",
    },
    subtitle: {
      en: 'Start your plan to keep generating with full access',
      fr: 'Démarrez votre abonnement pour continuer à générer avec un accès complet',
    },
    billedAnnually: {
      en: 'Billed annually',
      fr: 'Facturé annuellement',
    },
    chargeNotice: {
      en: 'We will charge your card today',
      fr: "Nous débiterons votre carte aujourd'hui",
    },
    confirmBtn: {
      en: 'Confirm and charge card',
      fr: 'Confirmer et débiter la carte',
    },
    skipBtn: {
      en: 'Not now',
      fr: 'Pas maintenant',
    },
  },
};
